<div class="wrapper">
    <span>{{data}} </span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()">
        <mat-icon>cancel</mat-icon>
    </button>
</div>
